const wrapper = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(4),
})

const link = (theme) => ({
  marginTop: theme.spacing(1),
})

export const styles = {
  wrapper,
  link,
}
